// extracted by mini-css-extract-plugin
export default {"finish-simplification-bar":"LetterFinishSimplificationBar_finish-simplification-bar__yeTyN","text-bold":"LetterFinishSimplificationBar_text-bold__IK0EE"};